import api from "app/lib/api";
import { BASE_URL } from "static/constants";
import { getFormattedDate } from "utils/date";

const field_mappings = {
  first_name: "firstName",
  last_name: "lastName",
  report_id: "reportId",
  account: "account",
  report_date: "reportDate",
  status: "status",
};

export const fetchApiJobs = async (query) => {
  const { pageSize, page, filters, sorting } = query;
  let url = `${BASE_URL}/v2/apiJob?`;
  url += "limit=" + pageSize;
  url += "&page=" + (page + 1);

  if (filters && filters.length > 0) {
    let filterQuery = [];
    filters.forEach((filter) => {
      filterQuery.push(
        `${field_mappings[filter.id]}=${
          filter.id === "report_date"
            ? getFormattedDate(filter.value, "YYYY-MM-DD")
            : filter.value
        }`
      );
    });
    url += `&${filterQuery.join("&")}`;
  }

  if (sorting?.length > 0) {
    const sortingQueries = sorting
      ?.map((sort) => {
        const { id, desc } = sort;
        const direction = desc ? "desc" : "asc";

        return `sortBy=${id}&order=${direction}&`;
      })
      ?.filter(Boolean)
      ?.join("");

    url += sortingQueries;
  }

  const { data } = await api.get(url);
  return data;
};

export const markApiJobComplete = async (jobs) => {
  const url = `${BASE_URL}/v2/apiJob/markComplete`;
  const { data } = await api.patch(url, jobs, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return data;
};

export const deleteApiJobs = async (jobs) => {
  const url = `${BASE_URL}/v2/apiJob/delete`;
  const { data } = await api.delete(
    url,
    { data: jobs },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return data;
};

export const retryApiJobs = async (jobs) => {
  const url = `${BASE_URL}/v2/apiJob/retry`;
  const { data } = await api.put(url, jobs, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return data;
};
